import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import DeletionBucketSection from 'app/components/DeletionBucketSection';
import { CustomerMallWiseTierHeader, TableHeaderConstant } from 'app/constants/table-header-constants';
import { ParseTableDate, formatToIndianRupee } from 'app/utils/Parsers';
import useCustomerMallWiseTier from './useCustomerMallWiseTier';

const CustomerMallWiseTier = ({ latestDeletionDate, latestRestorationDate }) => {
  const {
    pageLoading,

    flatData,
    flatTotal,
    flatPageCount,
    fetchFlat,

    beforeData,
    beforeTotal,
    beforePageCount,
    fetchBefore,

    afterData,
    afterTotal,
    afterPageCount,
    fetchAfter,

    dataPerPage,
  } = useCustomerMallWiseTier(latestDeletionDate, latestRestorationDate);

  // Column-aligned footer totals: Shopping Amount total under its column,
  // Past 12-Month (qualifying) Spend total under its column. Keys MUST equal
  // the column accessors so they land in the right <td>.
  const buildFooterData = (rows) => {
    if (!rows || rows.length === 0) return undefined;
    const shoppingTotal = rows.reduce(
      (sum, r) => sum + (Number(r.shoppingAmount) || 0),
      0
    );
    const migratedTotal = rows.reduce(
      (sum, r) => sum + (Number(r.migratedShopping) || 0),
      0
    );
    const qualifyingTotal = rows.reduce(
      (sum, r) => sum + (Number(r.qualifyingSpend) || 0),
      0
    );
    return {
      [TableHeaderConstant.MallNameKey]: 'Total',
      [TableHeaderConstant.ShoppingAmountKey]: formatToIndianRupee(
        shoppingTotal.toFixed(2)
      ),
      [TableHeaderConstant.MigratedShoppingKey]: formatToIndianRupee(
        migratedTotal.toFixed(2)
      ),
      [TableHeaderConstant.QualifyingSpendKey]: formatToIndianRupee(
        qualifyingTotal.toFixed(2)
      ),
    };
  };

  if (!latestDeletionDate) {
    return (
      <>
        <div className='cms-content__container'>
          <PaginatedTable
            columns={CustomerMallWiseTierHeader}
            data={flatData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={flatTotal}
            pageCount={flatPageCount}
            pageLoading={pageLoading}
            fetchData={fetchFlat}
            footerData={buildFooterData(flatData)}
          />
        </div>
        {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
      </>
    );
  }

  const boundaryFormatted = ParseTableDate(latestDeletionDate);
  const restorationFormatted = latestRestorationDate
    ? ParseTableDate(latestRestorationDate)
    : undefined;
  return (
    <>
      <div className='cms-content__container'>
        <DeletionBucketSection
          title='Account restored'
          captionDate={restorationFormatted}
          captionPrefix='Account restored on'
          isEmpty={afterData.length === 0}
        >
          <PaginatedTable
            columns={CustomerMallWiseTierHeader}
            data={afterData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={afterTotal}
            pageCount={afterPageCount}
            pageLoading={pageLoading}
            fetchData={fetchAfter}
            footerData={buildFooterData(afterData)}
          />
        </DeletionBucketSection>
        <DeletionBucketSection
          title='Account deleted'
          captionDate={boundaryFormatted}
          isEmpty={beforeData.length === 0}
        >
          <PaginatedTable
            columns={CustomerMallWiseTierHeader}
            data={beforeData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={beforeTotal}
            pageCount={beforePageCount}
            pageLoading={pageLoading}
            fetchData={fetchBefore}
            footerData={buildFooterData(beforeData)}
          />
        </DeletionBucketSection>
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default CustomerMallWiseTier;
